"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class ProgressChart extends React.PureComponent {
    render() {
        let _a = this.props, { value, min, max, showLimits, showProgressLabels, showIndicators, limitLabels, progressTotalText, progressCurrentText, indicatorCurrentText, indicatorRemainingText } = _a, other = __rest(_a, ["value", "min", "max", "showLimits", "showProgressLabels", "showIndicators", "limitLabels", "progressTotalText", "progressCurrentText", "indicatorCurrentText", "indicatorRemainingText"]);
        value = Math.min(value, max);
        let percent = ((value / max) * 100);
        let remainingPercent = (100 - percent);
        let greaterThanHalf = (percent > 50);
        let indicatorTextA;
        let indicatorTextB;
        let classNames = 'vf-chart vf-progress-chart';
        if (greaterThanHalf)
            classNames += ' right';
        if (showLimits)
            classNames += ' showLimits';
        if (showProgressLabels)
            classNames += ' showProgressLabels';
        if (showIndicators)
            classNames += ' showIndicators';
        let progressLabelA, progressLabelB;
        if (showProgressLabels) {
            progressLabelA = (React.createElement("div", { className: 'progress-label' }, progressTotalText));
            progressLabelB = (React.createElement("div", { className: 'progress-label' }, progressCurrentText));
        }
        let lineAStyles = {};
        let lineBStyles = {};
        indicatorTextA = null;
        indicatorTextB = null;
        if (showIndicators) {
            if (greaterThanHalf) {
                lineAStyles.right = remainingPercent + '%';
            }
            else {
                lineAStyles.left = percent + '%';
            }
            lineBStyles = {
                width: remainingPercent + '%',
                left: percent + '%'
            };
            indicatorTextA = (React.createElement("div", { className: "indicator a" }, indicatorCurrentText));
            indicatorTextB = (React.createElement("div", { className: "line b", style: lineBStyles },
                React.createElement("div", { className: "indicator b" }, indicatorRemainingText)));
        }
        return (React.createElement("div", Object.assign({}, other, { className: classNames }),
            indicatorTextA,
            React.createElement("div", { className: "-table", "data-min": limitLabels[0] || min, "data-max": limitLabels[1] || max },
                React.createElement("div", { className: "-cell" },
                    progressLabelA,
                    React.createElement("div", { className: 'points a' }),
                    React.createElement("div", { className: 'progress-wrapper' },
                        React.createElement("div", { className: 'progress', style: { width: percent + '%' } }, progressLabelB),
                        React.createElement("div", { className: "line a", style: lineAStyles })),
                    indicatorTextB))));
    }
}
ProgressChart.defaultProps = {
    min: 0,
    max: 100,
    showLimits: false,
    limitLabels: [],
    showProgressLabels: false,
    showIndicators: false
};
exports.default = ProgressChart;
